import React, { useState, useEffect } from 'react';

/* Icons */
import DutchIcon from 'symbols/language-nl.svg';
import GermanIcon from 'symbols/language-de.svg';
import EnglishIcon from 'symbols/language-en.svg';
import buttonIcon from 'symbols/arrow.svg';

/* Organisms */
import { Modal } from 'js/components/organisms';

/* Atoms */
import { Icon, Button } from 'js/components/atoms';

/* Utilities */
import { trans } from 'js/utilities';

export default function LanguageSwitch({ localizations }) {
    const [modalOpen, setModalOpen] = useState(false);
    const languages = Object.keys(localizations);
    const [currentLanguage, setCurrentLanguage] = useState('');
    const [newLanguage, setNewLanguage] = useState('');

    useEffect(() => {
        getCurrentLanguage();
    }, []);

    const getCurrentLanguage = () => {
        const currentUrl = window.location.href;
        if (!languages || (languages && languages.length === 0)) return false;

        languages.forEach((lang) => {
            if (currentUrl.includes(`/${lang}/`) || currentUrl.substring(currentUrl.lastIndexOf('/') + 1) === lang) {
                setCurrentLanguage(lang);
                setNewLanguage(lang);
            }
        });
    }

    const getLanguageIcon = (lang) => {
        switch(lang) {
            case 'nl':
                return DutchIcon;
            case 'de':
                return GermanIcon;
            case 'en':
                return EnglishIcon;
            default:
                return false;
        }
     }

    const changeCurrentLanguage = () => {
        const currentUrl = window.location.href;

        if (localizations[newLanguage] && localizations[newLanguage].url && localizations[newLanguage].url !== '') {
            window.location.href = localizations[newLanguage].url;
        } else {
            if (currentUrl.substring(currentUrl.lastIndexOf('/') + 1) === currentLanguage) {
                window.location.href = currentUrl.substring(0, currentUrl.lastIndexOf('/')) + `/${newLanguage}`;
            } else {
                window.location.href = currentUrl.replace(`/${currentLanguage}/`, `/${newLanguage}/`);
            }
        }
    }

    return (
        <div className="d-flex h-100">
            {currentLanguage !== '' && (
                <button type="button" className="btn btn-none btn--language font-weight-semi-bold" onClick={() => {
                    setNewLanguage(currentLanguage);
                    setModalOpen(true)
                }}>
                    <div className="btn__icon">
                        <Icon
                            {...{
                                size: 20,
                                className: 'icon-rounded icon--language'
                            }}
                            {...getLanguageIcon(currentLanguage)}
                        />
                    </div>
                    <span className="btn__text">
                        {trans(`header.language.${currentLanguage}`)}
                    </span>
                </button>
            )}
            {modalOpen && (
                <>
                    <Modal
                        key="languageModal"
                        open={modalOpen}
                        centered={false}
                        className="modal--languages"
                        title={trans('header.language.modal.title')}
                        handleClose={() => setModalOpen(false)}
                        restoreFocus={false}
                    >
                        <label className="form-label mb-4">{trans('header.language.modal.label')}</label>
                        <div className="choices-container">
                            {languages.map((lang, index) => (
                                <div key={index} className="custom-control custom-radio custom-radio--language">
                                    <input type="radio" className="custom-control-input" value={lang} defaultChecked={currentLanguage === lang} id={`language${index}`} name="language" onChange={() => setNewLanguage(lang)} />
                                    <label htmlFor={`language${index}`} className="custom-control-label">
                                        <Icon
                                            {...{
                                                size: 20,
                                                className: 'icon-rounded mr-2'
                                            }}
                                            {...getLanguageIcon(lang)}
                                        />
                                        {trans(`header.language.${lang}`)}
                                    </label>
                                </div>
                            ))}
                        </div>
                        <Button
                            theme="primary"
                            text={trans('header.language.modal.button')}
                            type="button"
                            className="text-white mt-6"
                            icon={buttonIcon}
                            onClick={() => changeCurrentLanguage()}
                        />
                    </Modal>
                </>
            )}
        </div>
    );
}
